module.exports = __webpack_public_path__ + "img/area-part3-211.ed908600.png";